import {
  Table,
  TableContainer,
  TableHead,
  TableBody,
  TableRow,
  TableCell,
  TableFooter,
  TablePagination,
  Input,
  Typography,
  Paper,
  TextField,
  IconButton,
} from "@material-ui/core";
import React from "react";
import ClearIcon from "@material-ui/icons/Clear";
import MicIcon from "@material-ui/icons/Mic";
import {
  microphoneCalibrationColumnStyle,
} from "../shared/MicrophoneCalibrationStatus";
import FilteredRow from "./filteredRow";

export default function FilteredTable({
  rowData,
  headers,
  page,
  rowsPerPage,
  count,
  inputHandler,
  filters,
  handleChangePage,
  handleChangeRowsPerPage,
  removeHandler,
  isDetailedData,
  updateData,
}) {
  return (
    <TableContainer component={Paper}>
      <Table>
        <TableHead>
          <TableRow>
            <TableCell>
              <Typography>{headers[0]}</Typography>
            </TableCell>

            <TableCell>
              <Typography>{headers[1]}</Typography>

              <TextField
                id="date"
                type="date"
                value={filters.date}
                onInput={(event) => {
                  inputHandler(event, "date", false);
                }}
              />

              {filters.date && (
                <IconButton
                  onClick={() => {
                    inputHandler("", "date", true);
                  }}
                  size="small"
                >
                  <ClearIcon />
                </IconButton>
              )}
            </TableCell>

            <TableCell>
              <Typography>{headers[2]}</Typography>
              <Input
                value={filters.model}
                onInput={(event) => {
                  inputHandler(event, "model");
                }}
              />
            </TableCell>

            <TableCell>
              <Typography>{headers[3]}</Typography>
              <Input
                value={filters.brand}
                onInput={(event) => {
                  inputHandler(event, "brand");
                }}
              />
            </TableCell>

            <TableCell>
              <Typography>{headers[4]}</Typography>
              <Input
                value={filters.manufacturer}
                onInput={(event) => {
                  inputHandler(event, "manufacturer");
                }}
              />
            </TableCell>

            <TableCell>
              <Typography>{headers[5]}</Typography>
              <Input
                value={filters.calibrator}
                onInput={(event) => {
                  inputHandler(event, "calibrator");
                }}
              />
            </TableCell>

            <TableCell
              align="center"
              style={microphoneCalibrationColumnStyle}
            >
              <MicIcon
                titleAccess="Kalibracja mikrofonu"
                aria-label="Kalibracja mikrofonu"
              />
            </TableCell>

            <TableCell>
              <Typography>{headers[6]}</Typography>
            </TableCell>

            <TableCell>
              <Typography>{headers[7]}</Typography>
            </TableCell>

            <TableCell>
              <Typography>{headers[8]}</Typography>
            </TableCell>
          </TableRow>
        </TableHead>

        <TableBody>
          {rowData.map((item) => (
            <FilteredRow
              id={item.id}
              key={item.id}
              rowData={item}
              removeHandler={removeHandler}
              isDetailedData={isDetailedData}
              updateData={updateData}
            />
          ))}
        </TableBody>

        <TableFooter>
          <TableRow>
            <TablePagination
              rowsPerPageOptions={[10, 20, 50]}
              rowsPerPage={rowsPerPage}
              page={page}
              count={count}
              onChangePage={handleChangePage}
              onChangeRowsPerPage={handleChangeRowsPerPage}
              labelRowsPerPage={"liczba kalibracji na stronę"}
              labelDisplayedRows={({ from, to, count }) =>
                `${from}-${to} z ${count}`
              }
            />
          </TableRow>
        </TableFooter>
      </Table>
    </TableContainer>
  );
}
